<section class="mbtop">
    <article class="account">
      <div class="container">
  
  
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="page_head">
              <div class="ph_icon"><i class="fa-regular fa-comments"></i></div>
              <div class="ph_text">
                <h1>Product Orders &amp; Chat</h1>
                <p>View your orders and chat with your assigned consultant in real time.</p>
              </div>
            </div>
          </div>
          <div style="display: none;" class="col-lg-12 col-md-9 col-sm-12">
            <div class="col-lg-6 col-xs-6 col-md-6 d-flex w-b">
              <h2> Product Orders History</h2>
            </div>
  
            <div class="search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
            (scrolled)="onScroll()" [scrollWindow]="true">
         
            <div class="" *ngIf="productOrderData.length>0">
              <div class="col-lg-12 col-md-12 col-sm-12  border card mb-2" *ngFor="let item of productOrderData">
                <div class="profile">
                  <div class="info">
                    <div class="row">
                        <div class="col-lg-2 col-md-6 col-sm-6">
                            <p><strong>Product Name:</strong></p>
                          </div>
                      <div class="col-lg-4 col-md-6 col-sm-6">
                        <p>{{item?.productName}}</p>
                      </div>
                      <div class="col-lg-2 col-md-6 col-sm-6">
                        <p><strong>Price :</strong></p>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-6">
                        <p>{{gS.currencySign}} {{item?.orderAmount}}</p>
                      </div>
  
                    </div>
                    <div class="row">
                      <div class="col-lg-2 col-md-6 col-sm-6">
                        <p><strong>Order Date:</strong></p>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-6">
                        <p> <span>{{item.createdAt|
                            date:'d-m-Y'}} </span> </p>
                      </div>
                      <div class="col-lg-2 col-md-6 col-sm-6">
                        <p><strong>Payment Status:</strong></p>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-6">
                        <p>Confirmed</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-2 col-md-6 col-sm-6">
                        <p><strong>Order Status:</strong></p>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-6">
                        <p> <span>{{item?.orderStatus?item?.orderStatus.replaceAll("_"," "):'N/A'}} </span> </p>
                      </div>
                      <div class="col-lg-2 col-md-6 col-sm-6"  *ngIf="item?.consultantName">
                        <p><strong>Consultant Name:</strong></p>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-6"  *ngIf="item?.consultantName">
                        <p>{{item?.consultantName}}</p>
                      </div>
                    </div>
                    <div class="row" *ngIf="item?.orderStatus">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <p class="chat_now" (click)="chatNow(item)">chat Now</p>
                      </div>
                    </div>
                  </div>
                </div>
  
                <!-- <div class="button">
                  <button type="button" class="rate-btn "data-bs-toggle="modal"data-bs-target="#rateConsulatation">Rate us</button>
                  <button type="button" class="btn btn-info" (click)="viewPalmOrder(item)">View
                    Order</button>
                </div> -->
               
              </div>
            </div>
            <div class="noDataFound" *ngIf="productOrderData?.length==0">
              <p>No Data Found</p>
            </div>
          </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 page_main">
            <div class="user_list">
                <app-user-list [orderId]="orderId" (selectedUser)="selectUser($event)"></app-user-list>
              </div>
              <div class="chat_window">
                <app-product-chat-window (openViewDetails)="openViewDetails($event)"></app-product-chat-window>
              </div>
        </div>
        </div>
      </div>
       <!-- Rate Consulatation Popup -->
       <div class="modal fade" id="rateConsulatation" tabindex="-1" aria-labelledby="rateConsulatationLabel"
       aria-hidden="true">
       <div class="modal-dialog">
           <div class="modal-content">
               <div class="modal-header">
                   <h5 class="modal-title" id="rateConsulatationLabel">Rate Consultation</h5>
                   <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"><img
                           src="../../assets/images/close.svg" alt=""></button>
               </div>
               <div class="modal-body">
                <div class="stars">
                  <img src="../../assets/images/stars.svg" alt="">
                </div>
                   <div class="form-control rating">
                       <label class="rate" for="rate">
                        <input  type="text" value="" id="rate"placeholder="Describe your experience with Advisor in few words...">
                       </label>
                   </div>
               </div>
               <div class="modal-footer justify-content-center">
                   <button type="button" class="btn btn-apply">Submit</button>
               </div>
           </div>
       </div>
   </div>
   <!-- Rate Consulatation Popup end-->
   
    </article>
  </section>

  <app-view-product-form-details *ngIf="viewDetailsOffcanvas" [orderData]="selectedUser" (close)="closeOffcanvas($event)"></app-view-product-form-details>
  